import { Field, Float, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Logistic } from '../Logistic'

@InputType()
export class LogisticItemUpdateShippingWeightArgs extends ActionArgs {
  @Field(() => ID)
  logisticId: string

  @Field(() => ID)
  logisticItemId: string

  /**
   * The line's TOTAL weight in pounds as typed by the user. The per-unit weight persisted on the
   * product is this divided by the quantity stored on the line, so neither a product id nor a
   * quantity is accepted here: both are read from the stored logistic line.
   */
  @Field(() => Float)
  weight: number
}

export interface ILogisticItemUpdateShippingWeight extends IAction<Logistic, LogisticItemUpdateShippingWeightArgs> {}
